module.exports = __webpack_public_path__ + "static/img/jiajuriyon.af24072.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/jiajuriyon.png
// module id = GTWg
// module chunks = 0